import './purposes.scss';

import Swiper from 'swiper';
import { A11y, EffectFade, Navigation, Pagination, Scrollbar } from 'swiper/modules';

class Purposes {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-purposes',
            sliderAttr: 'slider',
            slideAttr: 'slide'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$purporses = $element;
        this.$purporsesContainer = this.$purporses.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$purporsesSlides = this.$purporses.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.purposesSlider = null;

        if (this.$purporsesContainer && this.$purporsesSlides.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        this.initSlider();
    }

    initSlider () {
        this.purposesSlider = new Swiper(this.$purporsesContainer, {
            autoHeight: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            modules: [EffectFade, Navigation, Pagination, Scrollbar, A11y],
            speed: 500,
            slidesPerView: 1,
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide',
                paginationBulletMessage: 'Springe zu Slide {{index}}',
                firstSlideMessage: 'Dies ist der Erste Slide',
                lastSlideMessage: 'Dies ist der Letzte Slide',
                slideLabelMessage: 'Slide {{index}} von {{slidesLength}}'
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                clickable: true,
                formatFractionCurrent: (number) => {
                    return ('0' + number).slice(-2);
                },
                formatFractionTotal: (number) => {
                    return ('0' + number).slice(-2);
                }
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next'
            },
            scrollbar: {
                el: '.swiper-scrollbar'
            }
        });
    }

    destroySlider () {
        if (this.purposesSlider !== null) {
            this.purposesSlider.destroy(true, true);
            this.purposesSlider = null;
        }
    }
}

export { Purposes };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$purposes = $context.querySelectorAll('[data-purposes="root"]');
        for (let i = 0; i < $$purposes.length; i++) {
            const $purposes = $$purposes[i];

            const purposesAPI = new Purposes($purposes);
            $purposes.API = purposesAPI;
        }
    }
});
